import { useMemo, useState } from "react";
import type { LocationApi } from "./useGBPListingManagement";

export type StatusFilter =
  | "all"
  | "active"
  | "suspended"
  | "needsReverification"
  | "unpublished"
  | "unverified";

export function resolveStatus(loc: LocationApi): StatusFilter {
  const s = loc.status;
  if (!s) return "active";
  if (s.suspended)           return "suspended";
  if (s.needsReverification) return "needsReverification";
  if (!s.published)          return "unpublished";
  if (!s.verified)           return "unverified";
  return "active";
}

export function useLocationFilters(locations: LocationApi[]) {
  const [activeFilter, setActiveFilter] = useState<StatusFilter>("all");

  const counts = useMemo(() => {
    const c: Record<StatusFilter, number> = {
      all: locations.length,
      active: 0, suspended: 0,
      needsReverification: 0, unpublished: 0, unverified: 0,
    };
    locations.forEach((l) => { c[resolveStatus(l)]++; });
    return c;
  }, [locations]);

  const filtered = useMemo(() =>
    activeFilter === "all"
      ? locations
      : locations.filter((l) => resolveStatus(l) === activeFilter),
    [locations, activeFilter]
  );

  return { filtered, counts, activeFilter, setActiveFilter };
}